<template>
  <div class="footer-container clearfix">
    <div class="footer-content">
      <InfoItemI18n v-for="item in infoList" :key="item.left" :info="item" />
    </div>
  </div>
</template>

<script>
import InfoItemI18n from './InfoItemI18n'
import { defaultData } from '@/i18n/local'
import i18n from '@/mixins/i18n'
export default {
  name: 'Footer',
  components: { InfoItemI18n },
  mixins: [i18n],
  computed: {
    infoList() {
      return this.data.footerContent || []
    }
  },
  watch: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/var.scss';
.footer-container {
  height: 127px;
  width: 100%;
  margin-top: 72px;
  overflow: hidden;
  background: rgba(77,77,77,1);
  color: #fff;
  .footer-content {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    // padding-left: 22px;
    padding-top: 27px;
    font-size: $fontSize;
    
    .footer-l {
      width: 70px;
      height: 100%;
      overflow: hidden;
      img {
        width: 64px;
        height: 64px;
        object-fit: contain;
      }
      .image-container {
        background: #fff;
        width: 70px;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center
      }
      p {
        text-align: center;
        margin-top: 7px;
        font-size: 10px
      }
    }
    .footer-r {
      // padding-left: 35px;
      font-size: 12px;
      .footer-r-t {
        margin-top: 15px;
        margin-bottom: 25px;
        text-align: left;
        font-size: 12px;
      }
      .footer-r-b {
         text-align: left;
        span {
          display: inline-block;
          font-size: 12px;
        }
        .icp {
          margin-left: 90px;
          margin-right: 40px;
        }
      }
    }
  }
}
</style>
